import ClickAwayListener from '@mui/material/ClickAwayListener';
import UserIcon from '../../components/icons/UserIcon';
import UserMenuContent from './UserMenuContent';
import ViewOnScreen from '../../components/view-on-screen/ViewOnScreen';
import { activeMenu, dispatchCloseMenuEvent, dispatchToggleMenuEvent } from '../../utils/menu';
import { Dropdown, DropdownButton } from './Style';
import { Menu } from '../../types/menu';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';

function UserDropdown() {
  const location = useLocation();
  const theme = useTheme();
  const isSmallScreenBreakpoint = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.xs),
  );

  const [open, setOpen] = useState<boolean>(false);

  const handleClick = () => {
    dispatchToggleMenuEvent(Menu.USER_MENU);
  };

  const handleClickAway = () => {
    if (!isSmallScreenBreakpoint) {
      if (open) dispatchCloseMenuEvent(Menu.USER_MENU);
    }
  };

  useEffect(() => {
    if (open) dispatchCloseMenuEvent(Menu.USER_MENU);
  }, [location]);

  useEffect(() => {
    const subscription = activeMenu.subscribe((e) => {
      setOpen(e === Menu.USER_MENU);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Dropdown>
        <DropdownButton disableRipple onClick={handleClick}>
          <UserIcon />
        </DropdownButton>
        {open ? (
          <ViewOnScreen screen={{ up: 'xs' }}>
            <UserMenuContent />
          </ViewOnScreen>
        ) : null}
      </Dropdown>
    </ClickAwayListener>
  );
}

export default UserDropdown;
